import { useRef } from 'react';
import { Paperclip } from 'lucide-react';
import { IconButton } from '../icon-button/icon-button.tsx';

interface ChatComposerAttachButtonProps {
  label: string;
  /** What the file picker offers, as an `accept` list. */
  accept?: string;
  disabled: boolean;
  onPick: (files: FileList | null) => void;
}

/** The paperclip, and the hidden file picker it opens. */
export function ChatComposerAttachButton({
  label,
  accept,
  disabled,
  onPick,
}: ChatComposerAttachButtonProps) {
  const picker = useRef<HTMLInputElement>(null);

  return (
    <>
      <input
        ref={picker}
        type='file'
        multiple
        accept={accept}
        className='hidden'
        onChange={(event) => {
          onPick(event.target.files);
          /* Cleared, so picking the same file twice in a row still fires. */
          event.target.value = '';
        }}
      />
      <IconButton
        aria-label={label}
        size='sm'
        disabled={disabled}
        onClick={() => picker.current?.click()}
      >
        <Paperclip size={15} aria-hidden='true' />
      </IconButton>
    </>
  );
}
